import { Box, Typography, Divider } from '@mui/material';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import { useEffect } from 'react';
import CustomPositionCategoryTable from './components/position.category.table';
import PositionCategoryController from '../controller/position.category.controller';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import PositionCategoryHeader from './components/position.category.header';
import { PositionCategoryChildrenModel, PositionCategoryModalChildrenData } from '../data/position.category.child';
import { PositionCategoryModalNames } from '../data/position.category.modal.name';
import PositionCategoryModalView from './components/position.category.model.view';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import useScreenWidth from '../../../hooks/use-page-width';
const PositionCategory = () => {
    const cate = PositionCategoryController();
    const alert = CusttomAlertController();
    const width = useScreenWidth();
    useEffect(() => {
        cate.cateGetData(true, null);
    }, []);
    return (
        <>
            <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການໝວດໝູ່ຕໍາແໜ່ງ</Typography>


            <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: "15px" }}>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#f5f4f4',
                        borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                    }}
                >
                    <Box>
                        <PositionCategoryHeader ctrl={cate} handleOpenDialog={() => cate?.onHandleModal(PositionCategoryModalChildrenData.filter((e: PositionCategoryChildrenModel) => e.name.includes(PositionCategoryModalNames.CREATE))[0])} />
                        <Divider sx={{ backgroundColor: '#D9D9D9' }} />

                        <Typography
                            fontSize={18}
                            sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
                        >
                            <ManageAccountsOutlinedIcon />
                            <Typography marginLeft={"10px"}>
                                ຈັດການໝວດໝູ່ຕໍາແໜ່ງ
                            </Typography>
                        </Typography>
                        <CustomPositionCategoryTable cate={cate} alert={alert} />

                    </Box>
                </Box>
            </Box>

            <PositionCategoryModalView ctrl={cate} />
            <CustomAlertModal ctrl={alert} />
        </>
    )
}

export default PositionCategory;